import request from "../request";

/**
 * 获取党委下面的支部
 * @param {*} data
 */
export function getsBranchApi() {
  return request.post('/admin/organization/getsBranch', '', { passerr: true, isauth: true })
}

/**
 * 获取党费每月的详细数据统计
 * @param {organization,year} data
 *
 */
export function getsMoneyByYearDetailApi(data) {
  return request.post('/admin/party/getsByYearDetail', data, { passerr: true, isauth: true })
}

/**
 * 获取党费年统计
 * @param {organization,year} data
 */
export function getsMoneyByYearApi(data) {
  return request.post('/admin/party/getsByYear', data, { passerr: true, isauth: true })
}

/**
 * 获取党费月统计
 * @param {organization,month} data
 */
export function getsMoneyByMonthApi(data) {
  return request.post('/admin/party/getsByMonth', data, { passerr: true, isauth: true })
}

/**
 * 成员分布统计
 * @param {*} organization_id
 */
export function getsMemberOrganizationApi(organization_id) {
  return request.post('/admin/party/censusOrganization', { organization_id }, { passerr: true, isauth: true })
}

/**
 * 会议统计
 * @param {*} organization_id
 */
export function getsActivityByOrganizationApi(organization_id,year='') {
  return request.post('/admin/activity/censusActivityByOrganization', { organization_id,year }, { passerr: true, isauth: true })
}



// WEBPACK FOOTER //
// ./src/network/api/branch.js